// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 100vh;
  background: url("/assets/background.jpg") no-repeat center center fixed;
  background-size: cover;
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.login-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  box-sizing: border-box;
}

.login-panel {
  width: 460px;
  background-color: #fdfeff;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  padding: 30px 40px 20px;
}

.login-title {
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 300;
  color: #404040;
  font-size: 28px;
  text-align: center;
  margin-top: 0;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-bottom: 5px;
}

.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control:focus {
  outline: none;
  border-color: #66afe9;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}

.btn {
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 18px;
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  transition: background 0.15s ease-in-out;
}
.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-login {
  background: rgb(174, 0, 0);
}
.btn-login:hover:not(:disabled) {
  background: rgb(140, 0, 0);
}

.btn-facebook {
  background: #3b5998;
}
.btn-facebook:hover:not(:disabled) {
  background: #2d4373;
}

.btn-google {
  position: relative;
  overflow: hidden;
  background: #4285f4;
  padding-top: 5.25px;
  padding-bottom: 5.25px;
}
.btn-google:hover:not(:disabled) {
  background: #3367d6;
}

.google-btn__face {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  pointer-events: none;
}

.google-btn__logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  padding: 2px;
  background: #fff;
  border-radius: 3px;
}
.google-btn__logo svg {
  display: block;
}

.google-btn__gsi {
  position: absolute;
  inset: 0;
  z-index: 2;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(2);
  transform-origin: center;
}

.alert-danger {
  padding: 8px 14px;
  margin-bottom: 15px;
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  border-radius: 4px;
  color: #a94442;
  font-size: 14px;
}

.two-factor-intro {
  font-size: 14px;
  color: #555;
  margin: 0 0 15px;
  line-height: 1.5;
}

.qr-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.qr-code {
  width: 200px;
  height: 200px;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  background: #fff;
}

.manual-secret {
  font-size: 13px;
  color: #555;
  margin-bottom: 15px;
}
.manual-secret summary {
  cursor: pointer;
}
.manual-secret code {
  display: block;
  margin-top: 6px;
  padding: 6px 8px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 14px;
  letter-spacing: 2px;
  word-break: break-all;
  -webkit-user-select: all;
          user-select: all;
}

.code-input {
  font-size: 22px;
  height: 44px;
  letter-spacing: 6px;
  text-align: center;
}

.btn-secondary {
  background: #6c757d;
}
.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
}

.back-link {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #337ab7;
  cursor: pointer;
  margin-top: 5px;
}
.back-link:hover {
  text-decoration: underline;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
